export enum Status {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
  REMOVED = 'REMOVED',
  IN_TRASH = 'IN_TRASH',
}